/**
 * Lightweight axios calls for the coin economy + card rolls.
 * Lives in its own file so we don't bloat /lib/api.js.
 */
import { api } from "./api";

export const fetchCoinBalance = () =>
  api.get("/coins/balance").then((r) => r.data);

export const earnCoins = (event_type, note) =>
  api.post("/coins/earn", { event_type, note }).then((r) => r.data).catch(() => null);

export const fetchRollTiers = () =>
  api.get("/vault-cards/roll/tiers").then((r) => r.data);

export const rollCards = (tier) =>
  api.post("/vault-cards/roll", { tier }).then((r) => r.data);

/** Trigger background AI artwork generation for a card. Fire-and-forget so the
 *  reveal modal doesn't block on it — by the time the user views their
 *  collection the artwork is usually already cached. */
export const prewarmCardArtwork = (cardId) =>
  api.post(`/vault-cards/${cardId}/artwork/prewarm`).catch(() => null);
